import React  from 'react'
import { Typography, Grid } from "@mui/material";

import FilterAutocomplete from '../../shared/AutoCompeleteFillter';
const AlertHeader = ({headline  ,filter  , setFilterValue, filterValue}) => {
 
  const options = [

    {id:"ALL",value:"All",label:"All"},
    {id:"TEXT",value:"Text",label:"Text"},
    {id:"AMOUNT",value:"Amount",label:"Amount"},
    {id:"MATCHING",value:"Matching",label:"Matching"},
    {id:"GPI",value:"GPI",label:"GPI"},
  ]
 const handleChangeFilter = (newvalue) => {
  
  setFilterValue(newvalue)
 }
  return (
    <Grid
    container
    justifyContent="space-between"
    sx={{ marginBottom: "20px" }}
  >
    <Grid item>
      <Typography
        sx={{
          color: "#050D2E",
          fontSize: "1.125rem",
          fontWeight: "bold",
          lineHeight: "21px",
        }}
      >
        {headline}
      </Typography>
    </Grid>
    <Grid item>
      <Grid container spacing={1}>
      {filter &&<Grid item>
        <FilterAutocomplete
        options={options}
        width={152}
        selectedValue={filterValue}
        handleChangeSelection={handleChangeFilter}
        />
        </Grid>}
  
      </Grid>
    </Grid>
  </Grid>
  )
}

export default AlertHeader